// @flow

export const postInit = (form_data: ?FormData): * => ({
  method: "POST",
  mode: "cors",
  body: form_data,
});

export const graphQLInit = (data: string): * => {
  const formData = new FormData();
  formData.append("query", data);

  return { method: "POST", mode: "cors", body: formData };
};

export const putInit = (form_data: ?FormData): * => ({
  method: "PUT",
  mode: "cors",
  body: form_data,
});

export const getInit = {
  method: "GET",
  mode: "cors",
};

export const deleteInit = (form_data: ?FormData): * => ({
  method: "DELETE",
  mode: "cors",
  body: form_data,
});



// WEBPACK FOOTER //
// ./src/global/types/constants.js